import { Button, Form, Input, TextArea } from 'antd-mobile-v5'
import { CheckCircleFill } from 'antd-mobile-icons'
import { FormattedMessage, useIntl } from 'react-intl'
import React, { useEffect, useState } from 'react'

import { getStoreFullAddress } from '../common/utils'
import { useStoreSearch } from '../../services/hooks'

const SearchStoreInfo = ({ form, setStoreVerify, storeVerify, editable, initStoreInfo, required }) => {
  const { formatMessage } = useIntl()
  const [store, setStore] = useState(initStoreInfo)
  const { loading, run, data } = useStoreSearch({
    onSuccess: (data) => {
      if (data.error) {
        setStoreVerify(false)
        setStore(null)
        return
      }
      setStoreVerify(true)
      form.setFields([
        {
          name: 'storeNumber',
          errors: [],
        },
      ])
      setStore(data)
    },
    onError: (error) => {
      form.setFields([
        {
          name: 'storeNumber',
          errors: [error.clientMsg],
        },
      ])
      setStore(null)
      return true
    },
  })
  const search = () => {
    setStore(null)
    setStoreVerify(false)
    const storeNumber = form.getFieldValue('storeNumber')
    if (!storeNumber) {
      form.setFields([
        {
          name: 'storeNumber',
          errors: [formatMessage({ id: 'form-storeNum-empty-error' })],
        },
      ])
      return
    }
    if (!/^\d+$/.test(storeNumber)) {
      form.setFields([
        {
          name: 'storeNumber',
          errors: [formatMessage({ id: 'form-storeNum-format-error' })],
        },
      ])
      return
    }
    form.setFields([
      {
        name: 'storeNumber',
        errors: [],
      },
    ])
    run(storeNumber)
  }

  const validateField = (_, value) => {
    if (!required) return Promise.resolve()
    if (!value) return Promise.reject(new Error('潜店不能为空'))
    if (!storeVerify) return Promise.reject(new Error(formatMessage({ id: 'form-storeNum-verify-error' })))
    if (storeVerify && value) return Promise.resolve()
  }

  useEffect(() => {
    if (initStoreInfo) {
      setStoreVerify(true)
    }
  }, [initStoreInfo])

  return (
    <>
      <Form.Item
        label={formatMessage({ id: 'dm-form-store-number' })}
        name="storeNumber"
        rules={[{ required }, { validator: validateField }]}
        extra={
          storeVerify ? (
            <CheckCircleFill fontSize={24} color="rgb(150,219,90)" />
          ) : (
            <Button
              size="small"
              color="primary"
              fill="none"
              loading={loading}
              onClick={search}
              loadingText={formatMessage({ id: 'common-search-loading' })}
            >
              <FormattedMessage id="common-search-title" />
            </Button>
          )
        }
      >
        <Input
          readOnly={!editable}
          placeholder={formatMessage({ id: 'si-store-num' })}
          onChange={() => setStoreVerify(false)}
        />
      </Form.Item>
      {store && store.storeName && (
        <>
          <Form.Item label={formatMessage({ id: 'certlist-storeName' })}>
            <Input readOnly value={store.storeName} />
          </Form.Item>
          <Form.Item label={formatMessage({ id: 'form-store-address' })}>
            <TextArea readOnly autoSize value={getStoreFullAddress(store)} />
          </Form.Item>
        </>
      )}
    </>
  )
}

export default SearchStoreInfo
